import React, { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { companyAPI } from '../lib/api';
import { useAuth } from './AuthContext';

const DEFAULTS = {
  branch_label: 'Niederlassung',
  branch_label_plural: 'Niederlassungen',
  location_label: 'Standort',
  location_label_plural: 'Standorte',
};

const OrgLabelsContext = createContext({
  labels: DEFAULTS,
  refresh: () => {},
});

export const OrgLabelsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [labels, setLabels] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const res = await companyAPI.getOrgLabels();
      setLabels({ ...DEFAULTS, ...(res.data || {}) });
    } catch {
      setLabels(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) refresh();
  }, [isAuthenticated, refresh]);

  return (
    <OrgLabelsContext.Provider value={{ labels, refresh }}>
      {children}
    </OrgLabelsContext.Provider>
  );
};

// Bequemer Zugriff: { branch, branches, location, locations, refresh }
export const useOrgLabels = () => {
  const { labels, refresh } = useContext(OrgLabelsContext);
  return {
    branch: labels.branch_label,
    branches: labels.branch_label_plural,
    location: labels.location_label,
    locations: labels.location_label_plural,
    raw: labels,
    refresh,
  };
};
